import { Component, OnInit, ElementRef, Renderer2, Input, HostListener } from '@angular/core';
import { UsefulService } from '../../../../common/services/global/useful/useful.service';


@Component({
    selector: 'ui-logo',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" [ngClass]="logoClasses.svg" height="100%" class="{{logo?.class}}" width="100%"
            *ngIf="logo?.path && !iconLogo; else textLogo">
                <title>{{ logo?.alt }}</title>
                <use [attr.xlink:href]="logo.path.concat('#logo')" />
        </svg>

        <ng-template #textLogo><span class="logo-text" *ngIf="!iconLogo" [ngClass]="logoClasses.text">{{ logo?.alt }}</span></ng-template>
        <ui-icon *ngIf="iconLogo" type="brand" [icon]="logo?.icon" [ngClass]="logoClasses?.icon"></ui-icon>`,
    styleUrls: ['./ui-logo.component.scss'],
    host: {
        '[attr.tabindex]': 'clickable ? 0 : "-1"',
        'class': 'logo'
    }
})
export class UiLogoComponent implements OnInit {
    @Input() defaultLogo;
    @Input() clickable = false;
    @Input() iconLogo = false;
    @Input() isCustom = false;

    @Input() logoClasses = {
        svg: '',
        text: '',
        icon: ''
    }

    logo;

    constructor(
        private readonly renderer: Renderer2,
        private readonly el: ElementRef,
        private readonly usefulService: UsefulService,
    ) {}

    ngOnInit() {
        if (this.clickable) {
            this.renderer.addClass(this.el.nativeElement, 'pointer');
        }
        if (!this.isCustom) {
            this.logo = this.usefulService.getLogo(this.defaultLogo);
        } else {
            this.logo = {
                path: this.defaultLogo,
                alt: "logo"
            };
        }
    }

    @HostListener('keyup.enter', ['$event']) onEnter(event) {
        if (this.clickable){
            this.el.nativeElement.click();
        }
    }
}
